import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const InvitedSignUp = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: "invited-sign-up" */ './hocs')),
});
